import React from "react";
import { Link } from "react-router-dom";
import { blogPosts } from "../data/blogPosts";
import { HiArrowRight, HiCalendar } from "react-icons/hi";
import SEO from "../components/SEO";

const BlogCard = ({ post }) => (
  <Link
    to={`/blog/${post.slug}`}
    className="group bg-primary-50 rounded-xl overflow-hidden shadow-card hover:shadow-card-hover
               transition-all duration-300 hover:bg-white"
  >
    <div className="relative overflow-hidden h-32">
      <img
        src={post.image}
        alt={post.title}
        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
      />
    </div>
    <div className="p-3">
      <div className="flex items-center gap-1 text-xs text-neutral mb-1.5">
        <HiCalendar className="w-3 h-3 text-primary-400" />
        {post.date}
      </div>
      <h3 className="text-base font-semibold text-neutral-dark mb-1.5 group-hover:text-primary-500 transition-colors line-clamp-2">
        {post.title}
      </h3>
      <p className="text-neutral text-xs mb-2 line-clamp-2">{post.excerpt}</p>
      <span className="inline-flex items-center gap-1 text-primary-500 font-medium text-xs group-hover:gap-1.5 transition-all">
        Read More
        <HiArrowRight className="w-3 h-3" />
      </span>
    </div>
  </Link>
);

const BlogPage = () => {
  return (
    <>
      <SEO
        title="Blog - Latest News & Insights"
        description="Stay updated with the latest news, insights, and announcements from HexaPi Tech. Learn about AI, robotics, software development, and technology trends."
        url="https://hexapi.tech/blog"
      />
      <div className="pt-24 lg:pt-28 pb-16 min-h-screen bg-white">
      <div className="max-w-6xl mx-auto px-4 lg:px-8">
        {/* Page Header */}
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-600
                          text-sm font-medium rounded-full mb-4">
            Latest Updates
          </span>
          <h1 className="text-3xl lg:text-4xl font-bold text-neutral-dark mb-4">
            Our Blog
          </h1>
          <p className="text-neutral max-w-2xl mx-auto">
            Stay updated with the latest news, insights, and announcements from HexaPi Tech
          </p>
        </div>

        {/* Blog Grid */}
        {blogPosts.length > 0 ? (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
            {blogPosts.map((post) => (
              <BlogCard key={post.slug} post={post} />
            ))}
          </div>
        ) : (
          <div className="text-center py-16">
            <p className="text-neutral text-lg">No blog posts yet. Check back soon!</p>
          </div>
        )}

        {/* Back to Home */}
        <div className="text-center mt-14">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-50 text-primary-600
                       font-medium rounded-lg hover:bg-primary-100 transition-colors"
          >
            <HiArrowRight className="w-4 h-4 rotate-180" />
            Back to Home
          </Link>
        </div>
      </div>
      </div>
    </>
  );
};

export default BlogPage;
